import { Container, Grid, Typography, Box } from "@mui/material";
import React, { useState } from "react";
import classes from "../Styles/contact.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Contact from "../Components/Contact";
const ContactMe = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmittted] = useState(false);
  const handleChange = (e) => {
    setName(e.target.value);
  };
  const handleSubmit = () => {
    setName("");
    setEmail("");
    setMessage("");
    setSubmittted(true);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  const date = new Date();
  return (
    <>
      <Container disableGutters maxWidth="xl" className={classes.about_body}>
        <Grid container className={classes.grid_container}>
          <Grid
            item
            xs={12}
            sx={{
              display: { xs: "block", md: "none" },
              pl: { xs: 3, md: 0 },
              pb: { xs: 3, md: 0 },
              pt: 3,
              textAlign: "center",
            }}
          >
            <Typography className={classes.about_text}>_contact_me</Typography>
          </Grid>
          <Contact />

          <Grid
            item
            md={5}
            xs={12}
            sx={{
              borderRight: { xs: "none", md: "0.25px solid #1E2D3D" },
            }}
          >
            <Box
              sx={{
                overflowY: { xs: "visible", md: "scroll" },
                height: "100%",
              }}
              className={classes.about_overflow}
            >
              <Box
                sx={{
                  borderBottom: { xs: "none", md: "0.25px solid #1E2D3D" },
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      color: "#607B96",
                      borderRight: "0.25px solid #1E2D3D",
                      fontSize: "16px",
                      display: { xs: "none", md: "block" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 1.4,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    contacts
                    <CloseIcon
                      sx={{ fontSize: "18px", pt: 0.4, pl: 4, pr: 2 }}
                    />
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFFFFF",

                      fontSize: "16px",
                      display: { xs: "block", md: "none" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 5,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    {`// contacts`}
                  </Typography>
                </Box>
              </Box>
              {submitted ? (
                <Box
                  className={classes.contatct_container_thanks}
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                >
                  <Typography className={classes.submitted_thanks}>
                    Thank you! 🤘
                  </Typography>
                  <Typography className={classes.form_text}>
                    Your message has been accepted. You will recieve answer
                    really soon!
                  </Typography>
                  <button
                    type="button"
                    onClick={() => setSubmittted(false)}
                    className={classes.contact_button}
                  >
                    send-new-message
                  </button>
                </Box>
              ) : (
                <Box className={classes.contatct_container}>
                  <Box sx={{ mb: 2 }}>
                    <Typography className={classes.form_text}>
                      _name:
                    </Typography>
                    <input
                      type="text"
                      name="name"
                      fullWidth
                      value={name}
                      onChange={handleChange}
                      className={classes.contact_small}
                    />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography className={classes.form_text}>
                      _email:
                    </Typography>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={handleEmail}
                      className={classes.contact_small}
                    />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography className={classes.form_text}>
                      _message:
                    </Typography>
                    <textarea
                      name="message"
                      value={message}
                      onChange={handleMessage}
                      className={classes.contact_text}
                    />
                  </Box>
                  {email === "" || name === "" || message === "" ? (
                    <Typography className={classes.contact_button_text}>
                      Please fill form to continue
                    </Typography>
                  ) : (
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className={classes.contact_button}
                    >
                      <a
                        href="mailto:iadebiyi01@gmail.com"
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        submit-message
                      </a>
                    </button>
                  )}
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item md={4.6} sx={{ display: { xs: "none", md: "block" } }}>
            <Typography
              sx={{
                color: "#FFFFFF",

                fontSize: "16px",

                fontFamily: "'Fira Code', monospace !important",
                pt: 2,
                pb: 1,
                pl: 2,
              }}
            >
              <Box sx={{ display: { xs: "none", md: "block" }, p: 2 }}>
                <Typography sx={{ display: "flex", wordBreak: "break-word" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    1
                  </span>
                  <Box>
                    <span className={classes.about_const}>const</span>
                    <span className={classes.contact_other}>button</span>
                    <span>=</span>{" "}
                    <span className={classes.contact_other}>
                      document.querySelector
                    </span>
                    <span className={classes.contact_send}>('#sendBtn');</span>
                  </Box>
                </Typography>
                <Typography>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    2
                  </span>
                </Typography>
                <Typography sx={{ display: "flex" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    3
                  </span>
                  <Box>
                    <span className={classes.about_const}>const</span>
                    <span className={classes.contact_other}>message</span>
                    <span>{`= {`}</span>
                  </Box>
                </Typography>
                <Typography sx={{ display: "flex", wordBreak: "break-word" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    4
                  </span>
                  <Box>
                    <span className={classes.contact_other}>name:</span>
                    <span className={classes.contact_send}>{`"${name}",`}</span>
                  </Box>
                </Typography>
                <Typography sx={{ display: "flex", wordBreak: "break-word" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    5
                  </span>
                  <Box>
                    <span className={classes.contact_other}>email:</span>
                    <span
                      className={classes.contact_send}
                    >{`"${email}",`}</span>
                  </Box>
                </Typography>
                <Typography sx={{ display: "flex", wordBreak: "break-word" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    6
                  </span>
                  <Box>
                    <span className={classes.contact_other}>message:</span>
                    <span
                      className={classes.contact_send}
                    >{`"${message}",`}</span>
                  </Box>
                </Typography>
                <Typography sx={{ display: "flex", wordBreak: "break-word" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    7
                  </span>
                  <Box>
                    <span className={classes.contact_other}>date:</span>
                    <span
                      className={classes.contact_send}
                    >{`"${date.toLocaleString("default", {
                      weekday: "short",
                    })} ${date.getUTCDate()} ${date.toLocaleString("default", {
                      month: "short",
                    })}",`}</span>
                  </Box>
                </Typography>
                <Typography sx={{ display: "flex" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    8
                  </span>
                  <Box>
                    <span>{`}`}</span>
                  </Box>
                </Typography>
                <Typography>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    9
                  </span>
                </Typography>
                <Typography sx={{ display: "flex", wordBreak: "break-word" }}>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px", width: "30px" }}
                  >
                    10
                  </span>
                  <Box>
                    <span className={classes.contact_other}>
                      button.addEventListener
                    </span>
                    <span>(</span>
                    <span className={classes.contact_send}>'click'</span>
                    <span>, ( ) </span>
                    <span className={classes.about_const}>{` => `}</span>
                    <span>{`{`}</span>
                  </Box>
                </Typography>
                <Typography>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    11
                  </span>
                  <span className={classes.contact_other}>
                    form.send<span style={{ color: "white" }}>(</span>message
                    <span style={{ color: "white" }}>)</span>;
                  </span>
                </Typography>
                <Typography>
                  <span
                    className={classes.about_numbers}
                    style={{ paddingRight: "20px" }}
                  >
                    12
                  </span>
                  <span>{`})`}</span>
                </Typography>
              </Box>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ContactMe;
